import type {
  CustomBillingApiType,
  RefundSubmissionApiType,
} from 'features/AdsManagement/services/refund'

import type {
  Pph23BankAccountInterface,
  Pph23CustomBillingInterface,
  Pph23RefundRecordInterface,
} from 'features/AdsManagement/pages/AdsPph23Refund/types'

const parseAmount = (value: string | number | null | undefined): number | null => {
  if (value == null || value === '') return null

  const num = typeof value === 'string' ? parseInt(value, 10) : value
  return Number.isNaN(num) ? null : num
}

const trimOrNull = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim()
  return trimmed || null
}

const parseId = (value: string | number): number => {
  const num = typeof value === 'string' ? parseInt(value, 10) : value
  return Number.isNaN(num) ? 0 : num
}

const buildBankAccount = (item: RefundSubmissionApiType): Pph23BankAccountInterface | null => {
  if (!item.bank_name || !item.bank_account_number || !item.bank_account_name) return null

  return {
    bank_name: item.bank_name,
    account_number: item.bank_account_number,
    holder_name: item.bank_account_name,
  }
}

const parseNpwp = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim()
  return trimmed || null
}

const buildCustomBilling = (
  customBilling: CustomBillingApiType | null | undefined,
): Pph23CustomBillingInterface | null => {
  if (!customBilling) return null

  return {
    name: customBilling.name ?? '',
    npwp: customBilling.npwp ?? '',
  }
}

export const mapRefundSubmission = (item: RefundSubmissionApiType): Pph23RefundRecordInterface => ({
  refund_request_id: parseId(item.id),
  approval_submission_id: parseId(item.approval_id),
  seller_id: parseId(item.seller_id),
  seller_name: item.seller_name ?? '',
  requester_role: trimOrNull(item.requester_role),
  requester_email: trimOrNull(item.requester_email),
  npwp: parseNpwp(item.npwp),
  invoice_id: item.invoice_id,
  topup_amount: parseAmount(item.amount) ?? 0,
  refund_amount: parseAmount(item.refund_amount),
  refund_fee_amount: parseAmount(item.refund_fee_amount),
  refund_total_amount: parseAmount(item.refund_total_amount),
  created_at: item.created_at,
  reviewed_at: item.completed_at ?? null,
  reviewer_role: trimOrNull(item.reviewer_role),
  reviewer_name: trimOrNull(item.reviewer_name),
  status: item.status,
  rejection_note: item.rejection_note?.trim() ? item.rejection_note : null,
  bank_account: buildBankAccount(item),
  tax_slip: item.tax_slip ?? '',
  custom_billing: buildCustomBilling(item.custom_billing),
})
